// extracted by mini-css-extract-plugin
export default {"wrapper":"request-accepted-modal_wrapper__0Pub8","button":"request-accepted-modal_button__YxfbP","opacity-transition":"request-accepted-modal_opacity-transition__JMZfx"};